<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="商品名称"
          prop="productName"
        >
          <el-input v-model="createForm.productName" />
        </el-form-item>
        <el-form-item
          label="商品类型"
          prop="productType"
        >
          <el-select
            v-model="createForm.productType"
            filterable
            clearable
            placeholder="请选择商品类型"
          >
            <el-option
              v-for="product in productTypeList"
              :key="product.value"
              :label="product.label"
              :value="product.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="createForm.productType === 10"
          label="课程"
          prop="courseId"
        >
          <el-select
            v-model="createForm.courseId"
            filterable
            clearable
            placeholder="请选择课程"
          >
            <el-option
              v-for="course in courseList"
              :key="course.id"
              :label="course.value"
              :value="course.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="消耗积分"
          prop="pointsPrice"
        >
          <el-input v-model="createForm.pointsPrice" />
        </el-form-item>
        <el-form-item
          label="商品简介"
          prop="productDesc"
        >
          <el-input
            v-model="createForm.productDesc"
            type="textarea"
          />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import { productTypeList } from '@/config';

export default {
  name: 'ProductDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      title: '新建商品',
      cancelText: '取消',
      courseList: [],
      productTypeList: this._.cloneDeep(productTypeList),
      createForm: {
        productName: null,
        productType: null,
        courseId: null,
        pointsPrice: null,
        productDesc: null,
      },
      creatRules: {
        productName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
        productType: [
          { required: true, message: '请选择商品类型', trigger: 'blur' },
        ],
        courseId: [
          { required: true, message: '请选择课程', trigger: 'blur' },
        ],
        pointsPrice: [
          {
            required: true, message: '请输入消耗积分', trigger: 'blur',
          },
        ],
      },
      couponInfo: {},
    };
  },
  watch: {
    item(val) {
      console.log(val);
      if (val) {
        const {
          productName,
          productType,
          courseId,
          pointsPrice,
          productDesc,
          id,
        } = val;
        this.createForm = {
          productName,
          productType,
          courseId,
          pointsPrice,
          productDesc,
          id,
        };
      } else {
        this.createForm = {
          productName: null,
          productType: null,
          courseId: null,
          pointsPrice: null,
          productDesc: null,
        };
      }
    },
  },
  mounted() {
    this.getCourseList();
  },
  methods: {
    close() {
      this.$emit('update:item', null);
      this.$emit('update:dialogVisible', false);
      this.$refs.createForm.clearValidate();
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.points.upsertPointsProduct(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改商品成功');
          } else {
            this.$message.success('新增商品成功');
          }

          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
    async getCourseList() {
      this.courseList = await axClient.points.listNameByLive();
      if (this.productTypeList.length > 2) {
        this.productTypeList.shift();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}

</style>
